import { Injectable } from '@angular/core';

/**
 * Holds the current access token in memory only — never written to any
 * browser storage. This breaks the circular dependency that would arise if
 * JwtInterceptor injected AuthService (AuthService → ApiService → HttpClient
 * → JwtInterceptor).
 */
@Injectable({ providedIn: 'root' })
export class TokenStoreService {
  private token: string | null = null;

  get(): string | null {
    return this.token;
  }

  set(token: string | null): void {
    this.token = token;
  }
}
